import './EnableInputSection.scss';

import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';

import Box from 'components/Box';
import EnableButtonInput from 'components/forms/EnableButtonInput';
import Text, { Detail } from 'components/Text';

import cxHelpers from 'util/className';

@cxHelpers('EnableInputSection')
export default class EnableInputSection extends PureComponent {
  static propTypes = {
    name: PropTypes.string,
    value: PropTypes.bool.isRequired,
    onChange: PropTypes.func.isRequired,
    titleI18n: PropTypes.string.isRequired,
    detailI18n: PropTypes.string,
  };

  render() {
    const { value, onChange, titleI18n, detailI18n, name, ...boxProps } =
      this.props;

    return (
      <Box
        b
        bradius
        pam
        spacebetween
        borderbox
        {...boxProps}
        className={this.cx()}
      >
        <div>
          <Box mbxxs>
            <Text tag="h4" i18n={titleI18n} />
          </Box>
          {detailI18n && <Detail i18n={detailI18n} />}
        </div>
        <EnableButtonInput name={name} value={value} onChange={onChange} />
      </Box>
    );
  }
}
